// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchPageIconFaSearchtranssearchPageIconFaSearchtrans {
    position: absolute;
    top: 74px;
    right: 35px;
    width: 30px;
    height: 33px;
    z-index: 1;
}

.searchPageIconFasearch {
    position: absolute;
    top: 74px;
    right: 35px;
    width: 30px;
    height: 33px;
    z-index: 1;
}



@media (min-width:320px) {

    .searchPageIconFaSearchtranssearchPageIconFaSearchtrans {
        position: absolute;
        top: 112px;
        right: 15px;
        width: 25px;
        height: 38px;
        z-index: 1;
    }

    .searchPageIconFasearch {
        position: absolute;
        top: 60px;
        right: 8px;
        width: 25px;
        height: 38px;
        z-index: 1;
    }
}

@media (min-width:768px) {
    .searchPageIconFaSearchtranssearchPageIconFaSearchtrans {
        position: absolute;
        top: 73px;
        right: 20px;
        width: 25px;
        height: 38px;
        z-index: 1;
    }

    .searchPageIconFasearch {
        position: absolute;
        top: 103px;
        right: 27px;
        width: 25px;
        height: 38px;
        z-index: 1;
    }
}

@media (min-width:961px) {
    .searchPageIconFaSearchtranssearchPageIconFaSearchtrans {
        position: absolute;
        top: 73px;
        right: 22px;
        width: 25px;
        height: 38px;
        z-index: 1;
    }

    .searchPageIconFasearch {
        position: absolute;
        top: 103px;
        right: 40px;
        width: 25px;
        height: 38px;
        z-index: 1;
    }
}

@media (min-width:1025px) {
    .searchPageIconFaSearchtranssearchPageIconFaSearchtrans {
        position: absolute;
        top: 73px;
        right: 34px;
        width: 25px;
        height: 38px;
        z-index: 1;
    }

    .searchPageIconFasearch {
        position: absolute;
        top: 100px;
        right: 40px;
        width: 28px;
        height: 50px;
        z-index: 1;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Site/Settings/Label_Settings/Labels.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;;;AAIA;;IAEI;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,WAAW;QACX,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,WAAW;QACX,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,WAAW;QACX,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,WAAW;QACX,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,WAAW;QACX,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,WAAW;QACX,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,WAAW;QACX,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,WAAW;QACX,YAAY;QACZ,UAAU;IACd;AACJ","sourcesContent":[".searchPageIconFaSearchtranssearchPageIconFaSearchtrans {\n    position: absolute;\n    top: 74px;\n    right: 35px;\n    width: 30px;\n    height: 33px;\n    z-index: 1;\n}\n\n.searchPageIconFasearch {\n    position: absolute;\n    top: 74px;\n    right: 35px;\n    width: 30px;\n    height: 33px;\n    z-index: 1;\n}\n\n\n\n@media (min-width:320px) {\n\n    .searchPageIconFaSearchtranssearchPageIconFaSearchtrans {\n        position: absolute;\n        top: 112px;\n        right: 15px;\n        width: 25px;\n        height: 38px;\n        z-index: 1;\n    }\n\n    .searchPageIconFasearch {\n        position: absolute;\n        top: 60px;\n        right: 8px;\n        width: 25px;\n        height: 38px;\n        z-index: 1;\n    }\n}\n\n@media (min-width:768px) {\n    .searchPageIconFaSearchtranssearchPageIconFaSearchtrans {\n        position: absolute;\n        top: 73px;\n        right: 20px;\n        width: 25px;\n        height: 38px;\n        z-index: 1;\n    }\n\n    .searchPageIconFasearch {\n        position: absolute;\n        top: 103px;\n        right: 27px;\n        width: 25px;\n        height: 38px;\n        z-index: 1;\n    }\n}\n\n@media (min-width:961px) {\n    .searchPageIconFaSearchtranssearchPageIconFaSearchtrans {\n        position: absolute;\n        top: 73px;\n        right: 22px;\n        width: 25px;\n        height: 38px;\n        z-index: 1;\n    }\n\n    .searchPageIconFasearch {\n        position: absolute;\n        top: 103px;\n        right: 40px;\n        width: 25px;\n        height: 38px;\n        z-index: 1;\n    }\n}\n\n@media (min-width:1025px) {\n    .searchPageIconFaSearchtranssearchPageIconFaSearchtrans {\n        position: absolute;\n        top: 73px;\n        right: 34px;\n        width: 25px;\n        height: 38px;\n        z-index: 1;\n    }\n\n    .searchPageIconFasearch {\n        position: absolute;\n        top: 100px;\n        right: 40px;\n        width: 28px;\n        height: 50px;\n        z-index: 1;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
